import React from "react";

const ONSITE_LABELS = {
  carpets: "Carpets Cleaning",
  furniture: "Furniture Cleaning",
  car_cleaning: "Car Cleaning",
  housekeeping: "Housekeeping",
  house_keeping: "Housekeeping",
  disinfection: "Disinfection"
};

const fmtDate = (d) => {
  if (!d) return "";
  const s = String(d).substring(0, 10);
  if (s === "0000-00-00") return "";
  const [y, m, day] = s.split("-");
  return `${m}/${day}/${y}`;
};

const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = String(t).split(":");
  const hour = Number(h);
  const ampm = hour >= 12 ? "PM" : "AM";
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${h12}:${m} ${ampm}`;
};

/**
 * On-site service schedule chosen by the customer on the website
 * (carpets / furniture / car cleaning / housekeeping). These orders have no
 * pickup/drop-off time slots — the crew goes once, on order_service_date
 * between order_start_time and order_end_time. Renders nothing for
 * pickup/drop-off (laundry) or shop delivery orders.
 */
export default function OrderServiceTime({ order }) {
  const date = order?.order_service_date;
  const start = order?.order_start_time;
  const end = order?.order_end_time;

  if (!date || String(date).startsWith("0000") || !start || !end) return null;

  const typeLabel = ONSITE_LABELS[order?.order_type] || order?.order_type || "On-site service";

  return (
    <div className="card" style={{ marginBottom: "20px" }}>
      <div className="card-header">
        <h2>On-Site Service Time</h2>
      </div>
      <div className="card-body">
        <div style={{ display: "flex", gap: 40, flexWrap: "wrap", fontSize: 13 }}>
          <div>
            <div style={{ color: "#777", marginBottom: 2 }}>Service</div>
            <div style={{ fontWeight: 600 }}>{typeLabel}</div>
          </div>
          <div>
            <div style={{ color: "#777", marginBottom: 2 }}>Service Date</div>
            <div style={{ fontWeight: 600 }}>{fmtDate(date)}</div>
          </div>
          <div>
            <div style={{ color: "#777", marginBottom: 2 }}>Time Window (selected by customer)</div>
            <div style={{ fontWeight: 600 }}>
              {fmtTime(start)} – {fmtTime(end)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
